export const CHAPTER_HEADER_HEIGHT = 48;
export const RESULT_ITEM_HEIGHT = 64;
export const SEARCH_CHUNK_SIZE = 50;
export const DEBOUNCE_MS = 300;

export const ROW_TYPES = {
  CHAPTER_HEADER: 'CHAPTER_HEADER',
  RESULT_ITEM: 'RESULT_ITEM',
};

export const SUGGEST_DEBOUNCE_MS = 300;
export const SUGGEST_LIMIT = 5;
export const MAX_HISTORY_ENTRIES = 10;
export const INDEX_STATUS_POLL_INTERVAL_MS = 5000;
// Safety ceiling for the "must observe INPROGRESS once before clearing"
// guard in SearchPanel/index.js. If CSG never reports active for any
// reason, polling falls back to clearing isIndexing after this many ms so
// the user is not locked out of the menu indefinitely. 10 minutes covers
// even very large courses where the BE walk + CSG flip is slow.
export const INDEX_ACTIVE_OBSERVATION_TIMEOUT_MS = 10 * 60 * 1000;
